import React, { useEffect, useState } from 'react'

import {
  ReactComponent as CloseIcon,
} from '../../assets/svg/icon-close.svg'
import {
  ReactComponent as TwitterIcon,
} from '../../assets/svg/icon-twitter.svg'
import { ReactComponent as EmailIcon } from '../../assets/svg/icon-email.svg'
import { ReactComponent as CodeIcon } from '../../assets/svg/icon-code.svg'

import './styles/share-popup.scss'

const SharePopup = props => {
  const { setIsVisible, videoID } = props
  const { href } = window.location

  const handleCopy = e => {
    navigator.permissions.query({ name: 'clipboard-write' }).then((result) => {
      if (result.state === 'granted' || result.state === 'prompt') {
        navigator.clipboard.writeText(e.target.value)
          .then(console.log)
          .catch(console.error)
      }
    }).catch(() => {
      e.target.select()
      document.execCommand('copy')
    })

  }

  return (
    <div className="share-popup-container" onClick={e => {
      if (e.target.className === 'share-popup-container') {
        setIsVisible(false)
      }
    }}>
      <div
        className="share-popup"
        role="alertdialog"
        aria-describedby="share-popup-title">
        <div className="share-popup-inner">
          <header>
            <h3 className="share-popup__title" id="share-popup-details">
              Share video
            </h3>
            <button
              className="close-btn"
              type="button"
              onClick={() => setIsVisible(false)}
            >
              <CloseIcon/>
              <span className="visually-hidden">Close dialog</span>
            </button>
          </header>
          <div className="social-media">
            <CodeIcon/>

            <a
              href={`https://twitter.com/intent/tweet?text=Check%20out%20this%20video! ${href}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon/>
              <span className="visually-hidden">Share on Twitter</span>
            </a>
            <a
              href={`mailto:someone@mail.com?subject=Check%20out%20this%20cool%20video!&body=Check it out this cool video I found on CorpsTube ${href}`}>
              <EmailIcon/>
              <span className="visually-hidden">Share via email</span>
            </a>
          </div>
          <hr className="separator"/>
          <textarea
            className="embed-video"
            aria-label="Copy the embedded HTML code to display this video"
            value={`<iframe width="560" height="315" src="https://youtube.com/embed/${videoID}" title="Youtube video player" frameborder="0"></iframe>`}
            onClick={(e) => handleCopy(e)}
            rows="3"
            readOnly
          >
          </textarea>
        </div>
      </div>
    </div>
  )
}

export default SharePopup